let {Card} = require('./src/Entity/card'),
    {Hand} = require('./src/Entity/hand'),
    {Board} = require('./src/Entity/board'),
    {Player} = require('./src/Entity/player'),
    {Game} = require('./src/Game');



module.exports = {
    Card,
    Hand,
    Board,
    Player,
    Game,
};